module.exports = __webpack_public_path__ + "img/VJ.31866d5a.png";